import React, { useEffect } from "react"
import { Col, Container, Row } from "react-bootstrap"
import ContestDetails from "../components/ContestDetails/ContestDetails"
import WeeklyChallengeQuestions from "../components/ContestDetails/WeeklyChallengeQuestions"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { useHistory } from "react-router-dom"
import { useState } from "react"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { useDispatch, useSelector } from "react-redux"
import { viewWeeklyChallengeAction } from "redux/marketing/actions"
import { getViewChallengeQuestionsAction } from "redux/marketing/actions/user"
import { marketingActions } from "redux/marketing/slice/user"
import { appActions } from "redux/app/slice/app"

function ViewWeeklyChallenge() {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const dispatch = useDispatch()
  const history = useHistory()
  const { weeklyChallengeData, challengeQuestions, challengeQuestionsCount } = useSelector(
    (store) => store?.marketing
  )

  const handleEditContest = () => {
    dispatch(marketingActions.setIsContestEdited(false))
    history.push("/learning_development/dashboard/weekly-challenge/edit")
  }

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Weekly Challenge"
    dispatch(viewWeeklyChallengeAction())
    dispatch(getViewChallengeQuestionsAction())
    dispatch(appActions.setFilters({ category: [] }))
  }, [])

  const styles = {
    btn: {
      paddingLeft: "67px",
      paddingRight: "67px"
    }
  }

  return (
    <Container fluid className="ps-4 pe-4">
      <Row>
        <Col lg="12" className="ps-0">
          <Header title={weeklyChallengeData?.name ?? "-"} breadCrumbs={breadCrumbs}>
            {weeklyChallengeData?.status?.toLowerCase() === "draft" && (
              <AppButton onClick={handleEditContest} styles={styles.btn}>
                Edit Contest
              </AppButton>
            )}
          </Header>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <Row>
            <ContestDetails contestDetails={weeklyChallengeData} />
          </Row>
          <Row>
            <WeeklyChallengeQuestions
              questions={challengeQuestions}
              questionCount={challengeQuestionsCount}
            />
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default ViewWeeklyChallenge
